import { EndUserDashboard } from 'components/pages/end-user-dashboard/EndUserDashboard'

export const Dashboard: React.FC = () => <EndUserDashboard />
